import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetCalendar(appOptId) {
        return this.http.get('/api/Calendar/GetCalendar?appOptId=' + appOptId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetCalendarFilters(appOptId) {
        return this.http.get('/api/Calendar/GetCalendarFilters?appOptId=' + appOptId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
